var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "booking-seats"
  }, [_vm.showModeSelection ? _c('b-button-group', {
    staticClass: "booking-seats__type-wrapper"
  }, [_c('b-button', {
    class: {
      active: _vm.selectedMode === 'capacity'
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.selectedMode = 'capacity';
      }
    }
  }, [_vm._v(" 席次 ")]), _c('b-button', {
    class: {
      active: _vm.selectedMode === 'staff'
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.selectedMode = 'staff';
      }
    }
  }, [_vm._v(" 員工 ")]), _c('b-button', {
    class: {
      active: _vm.selectedMode === 'service'
    },
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": function click($event) {
        _vm.selectedMode = 'service';
      }
    }
  }, [_vm._v(" 服務 ")])], 1) : _vm._e(), _vm.selectedMode === 'capacity' ? _c('div', [_c('div', {
    staticClass: "booking-seats__grid-body",
    style: {
      '--slot-count': _vm.actualSlotCount
    }
  }, [_c('div', {
    staticClass: "booking-seats__row booking-seats__row--header"
  }, [_c('div', {
    staticClass: "booking-seats__time-label booking-seats__time-label--transparent"
  }), _vm._l(_vm.actualSlotCount, function (index) {
    return _c('div', {
      key: index,
      staticClass: "booking-seats__header-cell",
      class: {
        'booking-seats__header-cell--exceeded': index > _vm.maximumBookingSlotCount
      }
    }, [index <= _vm.maximumBookingSlotCount ? [_vm._v(" 席次 " + _vm._s(index) + " ")] : [_vm._v(" 超額 " + _vm._s(index - _vm.maximumBookingSlotCount) + " ")]], 2);
  })], 2)]), _c('div', {
    staticClass: "booking-seats__capacity-wrapper"
  }, [_c('div', {
    staticClass: "booking-seats__grid-body",
    style: Object.assign({
      '--slot-count': _vm.actualSlotCount
    }, _vm.cellMinHeight && {
      '--cell-min-height': "".concat(_vm.cellMinHeight, "px")
    })
  }, _vm._l(_vm.timePeriods, function (timePeriod, timePeriodIndex) {
    return _c('div', {
      key: timePeriod.start,
      staticClass: "booking-seats__row",
      attrs: {
        "data-row-index": timePeriodIndex
      }
    }, [_c('div', {
      staticClass: "booking-seats__time-label",
      class: {
        'booking-seats__time-label--full-border': _vm.timePeriodIsFull(timePeriod)
      }
    }, [_vm._v(" " + _vm._s(_vm.timePeriodDisplayedText(timePeriod)) + " ")]), _vm._l(_vm.actualSlotCount, function (index) {
      return _c('div', {
        key: "slot-".concat(index),
        staticClass: "booking-seats__body-cell booking-seats__body-cell--placeholder",
        class: {
          'booking-seats__body-cell--exceeded': index > _vm.maximumBookingSlotCount
        },
        attrs: {
          "data-column-index": index
        }
      });
    })], 2);
  }), 0), _c('div', {
    staticClass: "booking-seats__overlay",
    style: Object.assign({
      '--slot-count': _vm.actualSlotCount
    }, _vm.cellMinHeight && {
      '--cell-min-height': "".concat(_vm.cellMinHeight, "px")
    })
  }, _vm._l(_vm.capacityViewBookings, function (booking) {
    return _c('div', {
      key: booking.id,
      staticClass: "booking-seats__overlay-cell",
      style: {
        gridRow: booking.rowSpan > 1 ? "".concat(booking.gridRow, " / span ").concat(booking.rowSpan) : booking.gridRow,
        gridColumn: booking.gridColumn + 2
      }
    }, [_c('div', {
      staticClass: "booking-seats__booking-cell",
      attrs: {
        "id": "capacity-booking-".concat(booking.id),
        "tabindex": "0"
      }
    }, [_vm._v(" " + _vm._s(booking.title) + " ")]), _c('b-popover', {
      attrs: {
        "target": "capacity-booking-".concat(booking.id),
        "triggers": "focus",
        "placement": "top",
        "custom-class": "booking-detail-popover"
      }
    }, [_c('div', {
      staticClass: "booking-detail"
    }, [_c('div', {
      staticClass: "booking-detail__title"
    }, [_vm._v(_vm._s(booking.title))]), _c('div', {
      staticClass: "booking-detail__info"
    }, [booking.branchName ? _c('div', {
      staticClass: "booking-detail__row"
    }, [_c('span', {
      staticClass: "booking-detail__label"
    }, [_vm._v("分店：")]), _c('span', [_vm._v(_vm._s(booking.branchName))])]) : _vm._e(), _vm.getStaffName(booking) ? _c('div', {
      staticClass: "booking-detail__row"
    }, [_c('span', {
      staticClass: "booking-detail__label"
    }, [_vm._v("員工：")]), _c('span', [_vm._v(_vm._s(_vm.getStaffName(booking)))])]) : _vm._e(), _vm.getServiceName(booking) ? _c('div', {
      staticClass: "booking-detail__row"
    }, [_c('span', {
      staticClass: "booking-detail__label"
    }, [_vm._v("服務：")]), _c('span', [_vm._v(_vm._s(_vm.getServiceName(booking)))])]) : _vm._e(), _c('div', {
      staticClass: "booking-detail__row"
    }, [_vm.presetId ? _c('router-link', {
      staticClass: "booking-detail__link",
      attrs: {
        "to": {
          name: 'BookingCenterBookingEdit',
          params: {
            id: _vm.presetId,
            booking_id: booking.id
          }
        },
        "target": "_blank"
      }
    }, [_vm._v(" 查看明細 "), _c('i', {
      staticClass: "mdi mdi-open-in-new ml-1"
    })]) : _c('span', {
      staticClass: "booking-detail__link"
    }, [_vm._v(" 查看明細 "), _c('i', {
      staticClass: "mdi mdi-open-in-new ml-1"
    })])], 1)])])])], 1);
  }), 0)])]) : _vm._e(), _vm.selectedMode === 'staff' ? _c('div', {
    staticClass: "booking-seats__grid-body",
    style: Object.assign({
      '--slot-count': _vm.staffs.length
    }, _vm.cellMinHeight && {
      '--cell-min-height': "".concat(_vm.cellMinHeight, "px")
    })
  }, [_c('div', {
    staticClass: "booking-seats__row booking-seats__row--header"
  }, [_c('div', {
    staticClass: "booking-seats__time-label booking-seats__time-label--transparent"
  }), _vm._l(_vm.staffs, function (staff) {
    return _c('div', {
      key: staff.id,
      staticClass: "booking-seats__header-cell"
    }, [_vm._v(" " + _vm._s(staff.name) + " ")]);
  })], 2), _vm._l(_vm.timePeriods, function (timePeriod, timePeriodIndex) {
    return _c('div', {
      key: timePeriod.start,
      staticClass: "booking-seats__row"
    }, [_c('div', {
      staticClass: "booking-seats__time-label",
      class: {
        'booking-seats__time-label--full': _vm.timePeriodIsFull(timePeriod)
      }
    }, [_vm._v(" " + _vm._s(timePeriod.start) + " - " + _vm._s(timePeriod.end) + " ")]), _vm._l(_vm.staffs, function (staff, staffIndex) {
      var _vm$getBookingForCell, _vm$getBookingForCell2;
      return _c('div', {
        key: staff.id,
        staticClass: "booking-seats__body-cell",
        class: {
          'booking-seats__body-cell--empty': !_vm.getBookingForCell(timePeriod, staff)
        },
        on: {
          "click": function click($event) {
            !_vm.getBookingForCell(timePeriod, staff) && _vm.handleCellClick(timePeriod, staff);
          }
        }
      }, [_vm.getBookingForCell(timePeriod, staff) ? _c('div', {
        staticClass: "booking-seats__booking-cell",
        attrs: {
          "id": "staff-booking-".concat(timePeriodIndex, "-").concat(staffIndex),
          "tabindex": "0"
        }
      }, [_vm._v(" " + _vm._s(_vm.getBookingForCell(timePeriod, staff).title) + " ")]) : _vm._e(), _vm.getBookingForCell(timePeriod, staff) ? _c('b-popover', {
        attrs: {
          "target": "staff-booking-".concat(timePeriodIndex, "-").concat(staffIndex),
          "triggers": "focus",
          "placement": "top",
          "custom-class": "booking-detail-popover"
        }
      }, [_c('div', {
        staticClass: "booking-detail"
      }, [_c('div', {
        staticClass: "booking-detail__title"
      }, [_vm._v(_vm._s(_vm.getBookingForCell(timePeriod, staff).title))]), _c('div', {
        staticClass: "booking-detail__info"
      }, [(_vm$getBookingForCell = _vm.getBookingForCell(timePeriod, staff)) !== null && _vm$getBookingForCell !== void 0 && _vm$getBookingForCell.branchName ? _c('div', {
        staticClass: "booking-detail__row"
      }, [_c('span', {
        staticClass: "booking-detail__label"
      }, [_vm._v("分店：")]), _c('span', [_vm._v(_vm._s((_vm$getBookingForCell2 = _vm.getBookingForCell(timePeriod, staff)) === null || _vm$getBookingForCell2 === void 0 ? void 0 : _vm$getBookingForCell2.branchName))])]) : _vm._e(), staff.name ? _c('div', {
        staticClass: "booking-detail__row"
      }, [_c('span', {
        staticClass: "booking-detail__label"
      }, [_vm._v("員工：")]), _c('span', [_vm._v(_vm._s(staff.name))])]) : _vm._e(), _vm.getServiceName(_vm.getBookingForCell(timePeriod, staff)) ? _c('div', {
        staticClass: "booking-detail__row"
      }, [_c('span', {
        staticClass: "booking-detail__label"
      }, [_vm._v("服務：")]), _c('span', [_vm._v(_vm._s(_vm.getServiceName(_vm.getBookingForCell(timePeriod, staff))))])]) : _vm._e(), _c('div', {
        staticClass: "booking-detail__row"
      }, [_vm.presetId ? _c('router-link', {
        staticClass: "booking-detail__link",
        attrs: {
          "to": {
            name: 'BookingCenterBookingEdit',
            params: {
              id: _vm.presetId,
              booking_id: _vm.getBookingForCell(timePeriod, staff).id
            }
          },
          "target": "_blank"
        }
      }, [_vm._v(" 查看明細 "), _c('i', {
        staticClass: "mdi mdi-open-in-new ml-1"
      })]) : _c('span', {
        staticClass: "booking-detail__link"
      }, [_vm._v(" 查看明細 "), _c('i', {
        staticClass: "mdi mdi-open-in-new ml-1"
      })])], 1)])])]) : _vm._e()], 1);
    })], 2);
  })], 2) : _vm._e(), _vm.selectedMode === 'service' ? _c('div', {
    staticClass: "booking-seats__grid-body",
    style: Object.assign({
      '--slot-count': _vm.services.length
    }, _vm.cellMinHeight && {
      '--cell-min-height': "".concat(_vm.cellMinHeight, "px")
    })
  }, [_c('div', {
    staticClass: "booking-seats__row booking-seats__row--header"
  }, [_c('div', {
    staticClass: "booking-seats__time-label booking-seats__time-label--transparent"
  }), _vm._l(_vm.services, function (service) {
    return _c('div', {
      key: service.id,
      staticClass: "booking-seats__header-cell"
    }, [_vm._v(" " + _vm._s(service.name) + " ")]);
  })], 2), _vm._l(_vm.timePeriods, function (timePeriod, timePeriodIndex) {
    return _c('div', {
      key: timePeriod.start,
      staticClass: "booking-seats__row"
    }, [_c('div', {
      staticClass: "booking-seats__time-label"
    }, [_vm._v(" " + _vm._s(timePeriod.start) + " - " + _vm._s(timePeriod.end) + " ")]), _vm._l(_vm.services, function (service) {
      return _c('div', {
        key: service.id,
        staticClass: "booking-seats__body-cell booking-seats__body-cell--service",
        class: {
          'booking-seats__body-cell--full': _vm.isServiceTimePeriodFull(timePeriod, service) && timePeriodIndex % 2 === 0,
          'booking-seats__body-cell--full-border': _vm.isServiceTimePeriodFull(timePeriod, service) && timePeriodIndex % 2 === 1,
          'booking-seats__body-cell--empty': _vm.getBookingsForServiceCell(timePeriod, service).length === 0,
          'booking-seats__body-cell--clickable': !_vm.isServiceTimePeriodFull(timePeriod, service)
        },
        on: {
          "click": function click($event) {
            return _vm.handleCellClick(timePeriod, null, service);
          }
        }
      }, [_c('div', {
        staticClass: "booking-seats__service-bookings"
      }, [_vm._l(_vm.getVisibleBookingsForServiceCell(timePeriod, service), function (booking, bookingIndex) {
        return [_c('div', {
          key: booking.id,
          staticClass: "booking-seats__booking-row",
          attrs: {
            "id": "booking-".concat(timePeriodIndex, "-").concat(bookingIndex),
            "tabindex": "0"
          },
          on: {
            "click": function click($event) {
              $event.stopPropagation();
            }
          }
        }, [_vm._v(" " + _vm._s(booking.title) + " ")]), _c('b-popover', {
          attrs: {
            "target": "booking-".concat(timePeriodIndex, "-").concat(bookingIndex),
            "triggers": "focus",
            "placement": "top",
            "custom-class": "booking-detail-popover"
          }
        }, [_c('div', {
          staticClass: "booking-detail"
        }, [_c('div', {
          staticClass: "booking-detail__title"
        }, [_vm._v(_vm._s(booking.title))]), _c('div', {
          staticClass: "booking-detail__info"
        }, [booking.branchName ? _c('div', {
          staticClass: "booking-detail__row"
        }, [_c('span', {
          staticClass: "booking-detail__label"
        }, [_vm._v("分店：")]), _c('span', [_vm._v(_vm._s(booking.branchName))])]) : _vm._e(), _vm.getStaffName(booking) ? _c('div', {
          staticClass: "booking-detail__row"
        }, [_c('span', {
          staticClass: "booking-detail__label"
        }, [_vm._v("員工：")]), _c('span', [_vm._v(_vm._s(_vm.getStaffName(booking)))])]) : _vm._e(), _vm.getServiceName(booking) ? _c('div', {
          staticClass: "booking-detail__row"
        }, [_c('span', {
          staticClass: "booking-detail__label"
        }, [_vm._v("服務：")]), _c('span', [_vm._v(_vm._s(_vm.getServiceName(booking)))])]) : _vm._e(), _c('div', {
          staticClass: "booking-detail__row"
        }, [_vm.presetId ? _c('router-link', {
          staticClass: "booking-detail__link",
          attrs: {
            "to": {
              name: 'BookingCenterBookingEdit',
              params: {
                id: _vm.presetId,
                booking_id: booking.id
              }
            },
            "target": "_blank"
          }
        }, [_vm._v(" 查看明細 "), _c('i', {
          staticClass: "mdi mdi-open-in-new ml-1"
        })]) : _c('span', {
          staticClass: "booking-detail__link"
        }, [_vm._v(" 查看明細 "), _c('i', {
          staticClass: "mdi mdi-open-in-new ml-1"
        })])], 1)])])])];
      }), _vm.getHiddenBookingCount(timePeriod, service) > 0 ? [_c('div', {
        staticClass: "booking-seats__show-more",
        attrs: {
          "id": "popover-booking-list-".concat(timePeriod.id, "-").concat(service.id),
          "tabindex": "0"
        }
      }, [_vm._v(" +" + _vm._s(_vm.getHiddenBookingCount(timePeriod, service)) + " 顯示更多 ")]), _c('b-popover', {
        attrs: {
          "target": "popover-booking-list-".concat(timePeriod.id, "-").concat(service.id),
          "triggers": "focus",
          "placement": "top",
          "custom-class": "booking-list-popover"
        }
      }, [_c('div', {
        staticClass: "booking-list"
      }, _vm._l(_vm.getBookingsForServiceCell(timePeriod, service), function (booking) {
        return _c('div', {
          key: booking.id,
          staticClass: "booking-list__item"
        }, [_c('div', {
          staticClass: "booking-list__title"
        }, [_vm._v(_vm._s(booking.title))]), _c('div', {
          staticClass: "booking-list__info"
        }, [_c('span', {
          staticClass: "booking-list__label"
        }, [_vm._v("員工：")]), _vm._v(_vm._s(_vm.getStaffName(booking)) + " ")])]);
      }), 0)])] : _vm._e()], 2)]);
    })], 2);
  })], 2) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "新增預約",
      "ok-disabled": !_vm.bookingCreationIsValid
    },
    on: {
      "ok": _vm.confirmSelection,
      "cancel": _vm.cancelSelection
    },
    model: {
      value: _vm.showSelectionModal,
      callback: function callback($$v) {
        _vm.showSelectionModal = $$v;
      },
      expression: "showSelectionModal"
    }
  }, [_vm.showStaffSelect ? _c('b-form-group', {
    attrs: {
      "label": "請選擇員工"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.availableStaffOptions
    },
    model: {
      value: _vm.selectedStaffId,
      callback: function callback($$v) {
        _vm.selectedStaffId = $$v;
      },
      expression: "selectedStaffId"
    }
  })], 1) : _vm._e(), _vm.showServiceSelect ? _c('b-form-group', {
    attrs: {
      "label": "請選擇服務"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.availableServiceOptions
    },
    model: {
      value: _vm.selectedServiceId,
      callback: function callback($$v) {
        _vm.selectedServiceId = $$v;
      },
      expression: "selectedServiceId"
    }
  })], 1) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }